import Globalstyle from "./components/GlobalStyle";
import Homepage from "./Pages/Homepage";

function App() {
  return (
    <div className="App">
      <Globalstyle />
      <Homepage />
    </div>
  );
}

export default App;
